import { render, staticRenderFns } from "./CabeceraYTablas.vue?vue&type=template&id=732b515b"
import script from "./CabeceraYTablas.vue?vue&type=script&lang=js"
export * from "./CabeceraYTablas.vue?vue&type=script&lang=js"
import style0 from "./CabeceraYTablas.vue?vue&type=style&index=0&id=732b515b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports